import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://www.businessmateworkflow.in/api',
});

// Request interceptor to add auth token
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

// Response interceptor to handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Always clear a stale/invalid token.
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('rememberedEmail');

      // Only force a redirect to /login if the user is actually on a page
      // that requires auth. Previously this redirected unconditionally on
      // ANY 401 from ANY request - since the request interceptor above
      // attaches whatever token is in localStorage to every call, a single
      // stale/expired token was enough to bounce someone straight to
      // /login while they were just browsing the public homepage, a
      // service page, or a blog post.
      const protectedPrefixes = ['/dashboard', '/admin'];
      const isOnProtectedPage = protectedPrefixes.some((p) => window.location.pathname.startsWith(p));
      if (isOnProtectedPage) {
        window.location.href = '/login';
      }
    }

    return Promise.reject(error);
  }
);

export default api;